import {getFeedbackReviewFormulatrix, getFeedbackReviewLead} from '../../api/rest/feedbackApi';

export const getFormulatrixFeedback = async (periodeId) => {
  const req = await getFeedbackReviewFormulatrix(periodeId);
  console.log('result from formulatrix business', req.data);
  if (req) {
    return req.data;
  }
  return null;
};

export const getLeadFeedback = async (periodId, pageNo, pageSize) => {
  const req = await getFeedbackReviewLead(periodId, pageNo, pageSize);
  if (req) {
    return req.data;
  } else {
    return null;
  }
};
